export default "__VITE_ASSET__CS94i0b0__"